export const dateFormat = 'DD/MM/YYYY';

export const localeDate = {
  lang: {
    placeholder: 'Selecione uma Data',
    rangePlaceholder: ['Start date', 'End date'],
    today: 'Hoje',
    now: 'Agora',
    backToToday: 'Voltar para hoje',
    ok: 'Ok',
    clear: 'Limpar',
    month: 'Mês',
    year: 'Ano',
    timeSelect: 'Selecione o horário',
    dateSelect: 'Selecione uma Data',
    monthSelect: 'Escolha o mês',
    yearSelect: 'Escolha o ano',
    decadeSelect: 'Escolha a década',
    yearFormat: 'YYYY',
    dateFormat: dateFormat,
    dayFormat: 'DD',
    dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
    monthFormat: 'MMMM',
    monthBeforeYear: true,
    previousMonth: 'Mês anterior (PageUp)',
    nextMonth: 'Próximo mês (PageDown)',
    previousYear: 'Ano anterior (Control + left)',
    nextYear: 'Próximo ano (Control + right)',
    previousDecade: 'Década anterior',
    nextDecade: 'Próxima década',
    previousCentury: 'Século passado',
    nextCentury: 'Próximo século',
  },
  timePickerLocale: {
    placeholder: 'Selecione o horário',
  },
};

export const styleGutterRow = { xs: 8, sm: 16, md: 24 };
export const tableLocale =                 { 
  emptyText: 'Não há registros',
  filterTitle: 'Filtrar na lista',
  filterConfirm: 'Aplicar',
  filterReset: 'Limpar',
  sortTitle: 'Ordenar'
};

export const sorterWeekDay = [
  "Seg",
  "Ter",
  "Qua",
  "Qui",
  "Sex",
  "Sab",
  "Dom"
];

export const listaTipoBoleto = [
  { id: 'Fixo', descricao: 'Fixo' },
  { id: 'Link', descricao: 'Link' },
  { id: 'Movel', descricao: 'Móvel' },
];
export const listaFormaPgtoBoleto = [
  { id: 'BoletoCover', descricao: 'Boleto Cover' },
  { id: 'DebitoAutomatico', descricao: 'Débito automático' },
];



// WEBPACK FOOTER //
// ./src/common/configConstants.js